import html from '../images/html.png';
import css from '../images/css.png';
import js from '../images/js.png';
import sass from '../images/sass.png';
import bootstrap from '../images/bootstrap.png';
import react from '../images/react.png';
import redux from '../images/redux.png';
import next from '../images/nextjs.png';
import mui from '../images/mui.png';
import firebase from '../images/firebase.png';
import git from '../images/git.png';
import node from '../images/nodejs.png';
import express from '../images/expressjs.png';
import mongodb from '../images/mongodb.png';
import dart from '../images/dart.png';
import flutter from '../images/flutter.png';
import cloudinary from '../images/cloudinary.png';
import antd from '../images/antd.png';

let skillsData = [
    {
        name: 'HTML5',
        percentage: 90,
        image: html
    },
    {
        name: 'CSS3',
        percentage: 90,
        image: css
    },
    {
        name: 'JavaScript',
        percentage: 85,
        image: js
    },
    {
        name: 'SASS',
        percentage: 80,
        image: sass
    },
    {
        name: 'Bootstrap',
        percentage: 90,
        image: bootstrap
    },
    {
        name: 'React.JS',
        percentage: 85,
        image: react
    },
    {
        name: 'Redux',
        percentage: 40,
        image: redux
    },
    {
        name: 'React Native',
        percentage: 70,
        image: react
    },
    {
        name: 'Next.JS',
        percentage: 80,
        image: next
    },
    {
        name: 'Material UI',
        percentage: 80,
        image: mui
    },
    {
        name: 'Git',
        percentage: 80,
        image: git
    },
    {
        name: 'Firebase',
        percentage: 80,
        image: firebase
    },
    {
        name: 'Node.JS',
        percentage: 80,
        image: node
    },
    {
        name: 'Express.JS',
        percentage: 80,
        image: express
    },
    {
        name: 'Mongo DB',
        percentage: 80,
        image: mongodb
    },
    {
        name: 'Dart',
        percentage: 60,
        image: dart
    },
    {
        name: 'Flutter',
        percentage: 70,
        image: flutter
    },
    {
        name: 'Cloudinary',
        percentage: 50,
        image: cloudinary,
    },
    {
        name: 'Ant Design',
        percentage: 60,
        image: antd
    }
];

for (let i = 0; i < skillsData.length; i++){
    skillsData[i].id = i + 1;
};

export default skillsData;